import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dev-timezone-conf",
  "use": "icon-dev-timezone-conf-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-dev-timezone-conf\"><path d=\"M110,188.61A78.61,78.61,0,1,1,188.61,110,78.71,78.71,0,0,1,110,188.61Zm0-148.22A69.61,69.61,0,1,0,179.61,110,69.69,69.69,0,0,0,110,40.39Z\" /><polygon points=\"137.83 117.63 104.02 117.63 104.02 56.48 113.02 56.48 113.02 108.63 137.83 108.63 137.83 117.63\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol